/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TransactionDetailsStatusResponseItem } from './transaction-details-status-response-item';
import { TransactionTypeInfoResponseItem } from './transaction-type-info-response-item';


export interface TransactionDetailsResponse { 
    id: string;
    currencyName: string;
    currencyTicker: string;
    chainCode: string;
    chainName: string;
    accountName: string;
    amount: number;
    totalAmountInUsd: number;
    commission?: number | null;
    type: TransactionTypeInfoResponseItem;
    status: TransactionDetailsStatusResponseItem;
    createdDate: string;
    recipientAddress?: string | null;
    txId?: string | null;
    txExplorerUrl?: string | null;
    confirmationsReceived?: number | null;
    confirmationsRequired?: number | null;
}

